import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { MiningLandingPage } from './MiningLandingPage';

/**
 * Arche wrapper for DFE Mining — provides ArcheLayout and routing.
 *
 * DFE Mining is the mining engine behind LitCraft games, not a user-facing app.
 * End users land on a "nothing to see here" screen; there is no per-user browsing
 * surface. The live data path (external game, Lit Mining plugin, DFE Crafting)
 * runs entirely server-side and is independent of this UI.
 */
export function MiningArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<MiningLandingPage />} />
        {/* No user-facing sub-pages; deep links fall back to the landing. */}
        <Route path="/*" element={<Navigate to="/" replace />} />
      </Routes>
    </ArcheLayout>
  );
}
